import { createFileRoute, redirect } from '@tanstack/react-router'

import { isAllowedExternalRedirect } from 'lib/externalRedirect'

import Login from 'pages/Login'

export type LoginSearch = {
  redirect?: string
  redirectSearch?: Record<string, unknown>
  redirectHash?: string
  // Absolute, cross-origin URL to return to after login (the MCP OAuth bridge
  // lives on the api origin). Only honored when it passes
  // isAllowedExternalRedirect; otherwise ignored.
  externalRedirect?: string
}

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
    redirectSearch:
      search.redirectSearch &&
      typeof search.redirectSearch === 'object' &&
      !Array.isArray(search.redirectSearch)
        ? (search.redirectSearch as Record<string, unknown>)
        : undefined,
    redirectHash:
      typeof search.redirectHash === 'string' ? search.redirectHash : undefined,
    externalRedirect:
      typeof search.externalRedirect === 'string'
        ? search.externalRedirect
        : undefined,
  }),
  beforeLoad: ({ context, search }) => {
    if (context.auth.currentUser) {
      // Already logged in: an allowlisted external return URL wins (TanStack's
      // redirect() only navigates within the SPA, so a cross-origin return needs
      // a full-page navigation).
      if (isAllowedExternalRedirect(search.externalRedirect)) {
        window.location.replace(search.externalRedirect as string)
        return
      }
      throw redirect({
        to: search.redirect ?? '/',
        search: search.redirectSearch,
        hash: search.redirectHash,
      })
    }
  },
  component: Login,
})
